// extracted by mini-css-extract-plugin
module.exports = {"packing-list":"PackingList_packing-list__s0P7_"};